// root '../../../';

// dependencies
import { Child } from 'pym.js';
import { select } from 'd3-selection';

// polyfills
// import fetch from 'unfetch';
import './utils/polyfills'; // (includes Array.findIndex && Array.find)

// utils & graphic
import config, { cities } from './config';
import { initChart, updateChart } from './graphic';

// styles
import './styles/index.scss';

/* develblock:start */
import meta from './data/meta.json';

const pkg = require('../package.json');

let selectedCity = cities[0];
let lastWidth = null;
let chartInitialized = false;

if (process.env.NODE_ENV === 'development') {
  console.clear();
}

// eslint-disable-next-line  no-use-before-define
window.pymChild = new Child({ renderCallback: draw, id: pkg.name });

window.onload = () => {
  if (process.env.NODE_ENV === 'development') {
    Object.keys(meta).forEach((id) => {
      const node = document.querySelector(`.${id}`);

      if (node) {
        node.innerHTML = meta[id];
      }
    });
  }

  const { pymChild } = window;
  pymChild.sendHeight();
};

function onCityChange(city) {
  selectedCity = city;
  const container = select('#graphic');
  const fallbackWidth = container.node().clientWidth || 600;
  const safeWidth = lastWidth || fallbackWidth;
  const isMobile = safeWidth <= 500;

  const props = { initialWidth: safeWidth, isMobile, selectedCity };
  const graphicConfig = config(props);

  updateChart(graphicConfig, isMobile);

  const { pymChild } = window;
  if (pymChild) {
    pymChild.sendHeight();
  }
}

function draw(initialWidth) {
  const container = select('#graphic');
  const fallbackWidth = container.node().clientWidth || 600;
  const safeWidth = initialWidth !== fallbackWidth ? fallbackWidth : initialWidth;
  lastWidth = safeWidth;

  const isMobile = safeWidth <= 500;

  if (!chartInitialized) {
    container.html('');

    const dropdown = container.append('select')
      .attr('class', 'city-select')
      .on('change', function () {
        onCityChange(this.value);
      });

    dropdown.selectAll('option')
      .data(cities)
      .enter()
      .append('option')
      .attr('value', d => d)
      .text(d => d);

    const chartContainer = container.append('div').attr('class', 'chart-container');

    const props = { initialWidth: safeWidth, isMobile, selectedCity };
    const graphicConfig = config(props);

    initChart(graphicConfig, chartContainer, isMobile);
    chartInitialized = true;
  } else {
    const props = { initialWidth: safeWidth, isMobile, selectedCity };
    const graphicConfig = config(props);
    updateChart(graphicConfig, isMobile);
  }

  const { pymChild } = window;
  if (pymChild) {
    pymChild.sendHeight();
  }
}
